module.exports = __webpack_public_path__ + "static/media/congaparrot.49c06f79.gif";